import { render, staticRenderFns } from "./list-detail-panel-header.vue?vue&type=template&id=5fc2b1cc&scoped=true&"
import script from "./list-detail-panel-header.vue?vue&type=script&lang=ts&"
export * from "./list-detail-panel-header.vue?vue&type=script&lang=ts&"
import style0 from "./list-detail-panel-header.vue?vue&type=style&index=0&id=5fc2b1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2b1cc",
  null
  
)

export default component.exports